import { JoinBuyerFormController, SeoController } from '@application/components';
import { CACHE_KEY_CONTACT_MESSAGE } from '@application/constants';
import { ENV, environmentVariable } from '@application/env';
import { useRouter } from '@application/utils';
import { JoinBuyerPage } from '@presentation/pages';
import { GoogleOAuthProvider } from '@react-oauth/google';
import type { FC, ReactNode } from 'react';
import { useCallback, useMemo, useState } from 'react';

export const JoinBuyerPageController: FC = () => {
  const { translate, routeLocationDescriptor } = useRouter();
  const [showPostSignup, setShowPostSignup] = useState(false);

  const statusText = useMemo((): ReactNode | undefined => {
    if (typeof window !== 'undefined') {
      if (localStorage.getItem(CACHE_KEY_CONTACT_MESSAGE)) {
        return translate('signup.infoMessage.text');
      }
    }
  }, [translate]);

  const dismissMessageHandler = useCallback(() => {
    localStorage.removeItem(CACHE_KEY_CONTACT_MESSAGE);
  }, []);

  return (
    <>
      <SeoController
        title={translate('signup.buyer.seo.title')}
        description={translate('signup.buyer.seo.description')}
        keywords={translate('signup.buyer.seo.keywords')}
      />
      <JoinBuyerPage
        statusText={statusText}
        joinLink={routeLocationDescriptor('joinLanding')}
        onDismissMessageClick={() => dismissMessageHandler()}
        formComponent={
          <GoogleOAuthProvider clientId={environmentVariable(ENV.GOOGLE_ID)}>
            <JoinBuyerFormController
              loginLink={routeLocationDescriptor('login')}
              onShowPostSignup={() => setShowPostSignup(true)}
            />
          </GoogleOAuthProvider>
        }
        showPostSignup={showPostSignup}
      />
    </>
  );
};
